var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar",class:_vm.progressBarClass,style:({ width: _vm.profit + '%' })},[_c('span',{staticClass:"progress-label"},[_vm._v(_vm._s(_vm.profit)+"%")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }